var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('chanpin',{attrs:{"page_type":"1","user_type":"1","chanpin_type":"3"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }